import * as types from "./hospital.actionTypes";

export const handleStateSelection = (data) => {
  return {
    type: types.SET_SELECTED_STATE,
    payload: {
      state: data?.market,
      hospitalCount: data?.hospitalData?.total_hospitals,
      abbreviation: data?.abbrev,
      hospitalsList: data?.hospitalData?.data,
    },
  };
};

export const resetSelectedState = () => ({
  type: types.RESET_SELECTED_STATE,
});

export const setSelectedHospital = (hospital) => {
  return {
    type: types.SET_SELECTED_HOSPITAL,
    payload: hospital,
  };
};

export const setSpecificStateData = (payload) => ({
  type: types.SET_SPECIFIC_STATE_DATA,
  payload: payload,
});

export const resetSpecificStateData = () => ({
  type: types.RESET_SPECIFIC_STATE_DATA,
});